import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../config'

export async function saveValidateData(body) {
    const result = await axios.post(`${REACT_APP_API_ABM_FW}/dictionary`, body)
    return result.data
}
